import { render, staticRenderFns } from "./IssuedBooking.vue?vue&type=template&id=764ef36a&scoped=true"
import script from "./IssuedBooking.vue?vue&type=script&lang=js"
export * from "./IssuedBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764ef36a",
  null
  
)

export default component.exports